<template>
  <div class="error-message">
    <span class="error-icon">
      <icon name="circle-alert" />
    </span>
    <span class="error-text">{{
      error || $t('login.error.server-error')
    }}</span>
  </div>
</template>
<script>
import Icon from 'com/Icon'
export default {
  name: 'ErrorTips',
  components: { Icon },
  props: ['value'],
  data() {
    return {
      error: this.value
    }
  },
  watch: {
    value(val) {
      this.error = val
    },
    error(val) {
      this.$emit('input', val)
    }
  },
  reset() {
    this.error = null
  }
}
</script>
<style lang="less" scoped>
.error-message {
  display: flex;
  color: var(--red);
  font-size: 12px;
  font-weight: bold;
  align-items: flex-start;
  .error-icon {
    margin-right: 5px;
  }
  .icon {
    width: 12px;
    height: 12px;
    color: var(--red);
  }
}
</style>
